import '../styles/TituloSistema.css';

function Titulo() {
    return (
        <h1 className="titulo-sistema">SIGBI-712</h1>
    )
}

export default Titulo;